import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, signal, TemplateRef, ViewEncapsulation } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { IconType, QPointIconModule } from '@qpoint/icons';

@Component({
    selector: 'qpoint-table-row',
    templateUrl: './q-point-table-row.component.html',
    styleUrls: ['./q-point-table-row.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        CommonModule,
        TranslateModule,
        NgbTooltipModule,
        QPointIconModule
    ]
})
export class QPointTableRowComponent {
  public labelWidth = signal<number>(100);
  public _icon: string = null;
  public _showWarning = false;

  @Input() public label: string;
  @Input() public set icon(value: string) {
    this._icon = value;
    this.updateLabelWidth();
  }
  @Input() public iconType: IconType;
  @Input() public toolTip: TemplateRef<undefined> = null;
  @Input() public placement = 'top';
  @Input() public tooltipClass: string = null;
  @Input() public iconColor = '#69f';
  @Input() public set showWarning(value: boolean) {
    this._showWarning = value;
    this.updateLabelWidth();
  }
  @Input() public toolTipWarning: string = null;
  @Output() public iconMouseEvent = new EventEmitter<MouseEvent>();
  @Output() public iconMouseClickEvent = new EventEmitter<MouseEvent>();

  emitIconMouseEvent($event: MouseEvent) {
    this.iconMouseEvent.emit($event);
  }

  emitIconMouseClickEvent($event: MouseEvent) {
    this.iconMouseClickEvent.emit($event);
  }

  private updateLabelWidth() {
    let widthPercent = 100;
    if (this._showWarning) {
      widthPercent = widthPercent - 15;
    }
    if (this._icon?.length) {
      widthPercent = widthPercent - 15;
    }
    /* if only one icon additionally reduce width */
    this.labelWidth.set(widthPercent == 85 ? widthPercent - 5 : widthPercent);
  }
}
